<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <ValidationObserver ref="taggs">
          <v-col cols="10" class="content_category rounded-lg">
            <v-row class="mx-3">
              <v-col cols="6">
                <ValidationProvider
                  name="description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <ck-content
                    name="description"
                    class="ck-tag mt-3"
                    :content="tagDetail.description"
                    @getData="(value) => (tagDetail.description = value)"
                  />
                  <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      name="name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        background-color="#EDF2F7"
                        filled
                        :name="'name'"
                        :text="tagDetail.name"
                        v-model="tagDetail.name"
                        @keyup="onKeyUp"
                        label="Tên"
                        placeholder="Nhập tên category"
                      ></v-text-field>
                      <span class="validate-error red--text">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      name="slug"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        background-color="#EDF2F7"
                        filled
                        :name="'slug'"
                        v-model="tagDetail.slug"
                        :text="tagDetail.slug"
                        label="Slug"
                        placeholder="Nhập tên slug"
                      ></v-text-field>
                      <span class="validate-error red--text">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" >
                    <v-file-input
                      label="Ảnh"
                      placeholder="Tải ảnh lên"
                      prepend-icon="mdi-camera"
                      @change="fileSelected"
                    ></v-file-input>
                    <v-img :src="src ? src : tagDetail.photo_url" class="img-tag"></v-img>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn color="primary" width="180" @click="update_tag">
                  Lưu
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </ValidationObserver>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  UPLOAD_TAG_IMAGE,
  GET_DETAIL_TAG,
  UPDATE_TAG,
} from "@/store/modules/tag";
import CkContent from "@/components/ck-content";
import { replaceCkContent } from '@/utils/helpers'
import { mapGetters } from "vuex";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from "vee-validate/dist/vee-validate.full";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    CkContent,
  },
  data() {
    return {
      src: "",
      image: {},
      hasImage: false,
      selectedFile: null,
      page: "Quản lý Tag",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý sản phẩm",
          disabled: true,
        },
        {
          text: "Quản lý Tag",
          disabled: true,
        },
        {
          text: "Sửa Tag",
          disabled: true,
        },
      ],
    };
  },
  mounted() {
    localize({
      vi: {
        names: {
          description: "Mô tả",
          name: "Tên",
          slug: "Slug",
        },
        messages: {
          required: "{_field_} " + "không được bỏ trống!",
        },
      },
    });
    localize("vi");
  },
  async created() {
    await this.$store.dispatch(`${GET_DETAIL_TAG}`, this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      tagDetail: "tagDetail",
    }),
  },
  methods: {
    fileSelected(event) {
      if (!event) {
        this.src = "";
        this.tagDetail.photo_url = "";
      }
      this.image = event;
      this.src = URL.createObjectURL(this.image);
      if (this.image) {
        this.hasImage = !this.hasImage;
      }
      let formData = new FormData();
      formData.append("upload", this.image);
      formData.append("type", "tags");
      this.$store.dispatch(`${UPLOAD_TAG_IMAGE}`, formData).then((data) => {
        if (data) {
          this.tagDetail.media_id = data.data.data[0].media_id;
        }
      });
    },
    update_tag() {
      let result = this.$refs.taggs.validate();
      if (result) {
        if (!this.tagDetail.name) {
          return false;
        } else if (!this.tagDetail.slug) {
          return false;
        }
        if (!this.tagDetail.description) {
          return false;
        } else {
          this.tagDetail.description = replaceCkContent(this.tagDetail.description);
          this.$store.dispatch(`${UPDATE_TAG}`, this.tagDetail).then((data) => {
            if (data) {
              if(data.data.status == 1) {
                this.$toasted.success('Cập nhật thành công!', {
                  duration:1000,
                  position:'top-center'
                })
                this.$router.push('/manage_productions/tag')
              }
            }
          });
        }
      }
    },
    onKeyUp(value) {
      this.tagDetail.slug = this.sanitizeTitle(value.target.value);
    },
    sanitizeTitle(title) {
      // Change to lower case
      var str = title.toLowerCase();
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
      // Trim the last whitespace
      str = str.replace(/\s*$/g, "");
      // Change whitespace to "-"
      str = str.replace(/\s+/g, "-");

      return str;
    },
  },
};
</script>
<style lang="scss">
.content_category {
  background: #ffffff !important;
  .content-textarea .v-input__control {
    height: 200px !important;
  }
}
.ck-tag .ck-editor__main .ck-content {
  height: 200px;
}
.img-tag {
  object-fit: contain;
  width: 100%;
  max-width: 500px;
}
</style>